import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';
import { COLUMN_GAP } from '../shared.js';

export const useStyles = makeStyles({
    packedGroup: {
        display: 'grid',
        width: '100%',
        gridAutoFlow: 'dense',
        gap: `${px(COLUMN_GAP)}`,
        containerType: 'inline-size',
    },
    packedGroupCompact: {
        columnGap: tokens.spacingVerticalXXL,
        rowGap: tokens.spacingVerticalM,
    },
});
